var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimelineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "art",
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 105,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 22.5,
    y1: 53.25,
    x2: 82.5,
    y2: 53.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    className: "stop2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    className: "stop1"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81,72h-5.71c-.52-1.83-1.96-3.27-3.79-3.79v-8.71h6c.83,0,1.5-.67,1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5h-15c-.83,0-1.5.67-1.5,1.5v9c0,.83.67,1.5,1.5,1.5h6v8.71c-1.83.52-3.27,1.96-3.79,3.79h-6.93c-.52-1.83-1.96-3.27-3.79-3.79v-28.71h6c.83,0,1.5-.67,1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5h-15c-.83,0-1.5.67-1.5,1.5v9c0,.83.67,1.5,1.5,1.5h6v28.71c-1.83.52-3.27,1.96-3.79,3.79h-6.43c-.52-1.83-1.96-3.27-3.79-3.79v-8.71h6c.83,0,1.5-.67,1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5h-15c-.83,0-1.5.67-1.5,1.5v9c0,.83.67,1.5,1.5,1.5h6v8.71c-1.83.52-3.27,1.96-3.79,3.79h-6.21c-.83,0-1.5.67-1.5,1.5s.67,1.5,1.5,1.5h6.21c.66,2.3,2.77,4,5.29,4s4.63-1.7,5.29-4h6.43c.66,2.3,2.77,4,5.29,4s4.63-1.7,5.29-4h6.93c.66,2.3,2.77,4,5.29,4s4.63-1.7,5.29-4h5.71c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5ZM35.5,76c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5,2.5,1.12,2.5,2.5-1.12,2.5-2.5,2.5ZM52.5,76c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5,2.5,1.12,2.5,2.5-1.12,2.5-2.5,2.5ZM70,76c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5,2.5,1.12,2.5,2.5-1.12,2.5-2.5,2.5Z",
    fill: "url(#linear-gradient)",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineIcon);
export default __webpack_public_path__ + "static/media/timeline-icon.b8b675dac4ebe0030d1aded8d289d006.svg";
export { ForwardRef as ReactComponent };